import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import useMedia from "use-media";
import CommonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import Const from "../../../const/RTCC/Const";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getPassportInfo } from "../../../const/RTCC";
import MessageConst from "../../../const/RTCC/messageConst";
import common from "../../../resources/RTCC/js/common/common";
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { InputPassportList } from "../../molecules/RTCC/inputPassportList";
import './../../../resources/RTCC/css/passport/passport.css';
import { FooterContainer } from './footerContainer';
import { ErrorMassage } from '../../molecules/RTCC/errorMassage';
import { useRtoaster } from "../../../hooks/useRtoaster";


const RtccInputPassportContainer = (props) => {
    const {
        toUserInputInfo,
        passportInfo,
        setPassportInfo,
        setToUserInputInfo,
        onChange } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    const urlParam = useParams();

    const [linkList, setLinkList] = useState([]);
    const [roomNum, setRoomNum] = useState(toUserInputInfo.roomNum);
    const [represent, setRepresent] = useState({
        roomCount: "",
        guestSeq: "",
        guestNameRoman: "",
        passportNumber: "",
        issueDate: "",
        validDate: ""
    });
    const [yearListIssued, setYearListIssued] = useState([]);
    const [yearListValid, setYearListValid] = useState([]);
    const [monthList, setMonthList] = useState([]);
    const [dayList, setDayList] = useState([]);
    const [accompanyList, setAccompanyList] = useState([]);
    const [representFlgInfo, setRepresentFlgInfo] = useState({});
    const [accompanyFlgList, setAccompanyFlgList] = useState([]);
    const [errorInfo, setErrorInfo] = useState({
        errorMessage: null,
        errorFlg: false,
    });

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setToUserInputInfo(toUserInputInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }]);
        if (!passportInfo.represent && !passportInfo.accompanyList) {
            common.doPost(getPassportInfo, { reserveId: toUserInputInfo.reserveId }, afterGetPassportInfo);
        } else {
            setRepresent(passportInfo.represent);
            setAccompanyList(passportInfo.accompanyList);
        }
        // パスポート発行年月日/有効期間満了年月日選択リスト作成
        const today = new Date();
        const baseYear = today.getFullYear();
        let newYearListIssued = [{ id: "0", value: "年", selected: true }];
        for (let i = baseYear; i >= baseYear - Const.PASSPORT_VAILD_PERIOD; i--) {
            newYearListIssued.push({ id: "" + i, value: i, selected: false });
        }
        setYearListIssued(newYearListIssued);
        let newYearListValid = [{ id: "0", value: "年", selected: true }];
        for (let i = baseYear; i <= baseYear + Const.PASSPORT_VAILD_PERIOD; i++) {
            newYearListValid.push({ id: "" + i, value: i, selected: false });
        }
        setYearListValid(newYearListValid);
        let newMonthList = [{ id: "0", value: "月", selected: true }];
        Const.ENG_MONTH_ABBR.forEach(value => {
            newMonthList.push({ id: value.abbrName, value: value.abbrName, selected: false });
        })
        setMonthList(newMonthList);
        let newDayList = [{ id: "0", value: "日", selected: true }];
        for (let i = 1; i <= 31; i++) {
            newDayList.push({ id: i < 10 ? "0" + i : "" + i, value: i < 10 ? "0" + i : "" + i, selected: false });
        }
        setDayList(newDayList);

    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetPassportInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let info = data.passportInfo;
            let accompanyList = [];
            info.forEach((value, index) => {
                let issueDateList = [];
                if (value.issueDate) {
                    value.issueDate = CommonUtil.convPassportDate(value.issueDate, false)
                    issueDateList = value.issueDate.split(" ");
                }
                let validDateList = [];
                if (value.validDate) {
                    value.validDate = CommonUtil.convPassportDate(value.validDate, false)
                    validDateList = value.validDate.split(" ");
                }
                let srcUrl = document.referrer;
                if (value.representFlg) {
                    if (srcUrl.indexOf("inputPassportConfirm") != -1 && passportInfo[index] && passportInfo[index].representFlg) {
                        setRepresent(passportInfo[index]);
                    } else {
                        let newObj = {...value};
                        newObj.issueYear = issueDateList?.[2] ? issueDateList[2] : "0";
                        newObj.issueMonth = issueDateList?.[1] ? issueDateList[1] : "0";
                        newObj.issueDay = issueDateList?.[0] ? issueDateList[0] : "0";
                        newObj.validYear = validDateList?.[2] ? validDateList[2] : "0";
                        newObj.validMonth = validDateList?.[1] ? validDateList[1] : "0";
                        newObj.validDay = validDateList?.[0] ? validDateList[0] : "0";
                        setRepresent(newObj);
                    }
                } else {
                    if (srcUrl.indexOf("inputPassportConfirm") != -1 && passportInfo[index] && !passportInfo[index].representFlg) {
                        accompanyList.push(passportInfo[index]);
                    } else {
                        let newObj = {...value};
                        newObj.issueYear = issueDateList?.[2] ? issueDateList[2] : "0";
                        newObj.issueMonth = issueDateList?.[1] ? issueDateList[1] : "0";
                        newObj.issueDay = issueDateList?.[0] ? issueDateList[0] : "0";
                        newObj.validYear = validDateList?.[2] ? validDateList[2] : "0";
                        newObj.validMonth = validDateList?.[1] ? validDateList[1] : "0";
                        newObj.validDay = validDateList?.[0] ? validDateList[0] : "0";
                        accompanyList.push(newObj);
                    }
                }
            });
            setAccompanyList(accompanyList);
            setPassportInfo(info);
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/bookingConfirmDetail");
    }
    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {
        let errorMessageBox = [];
        let errorFlg = false;
        let passportInfoList = [];
        let accFlgList = [];
        let repFlgInfo = {
            errPassportNum: false,
            errIssueDate: false,
            errValidDate: false
        };
        const today = CommonUtil.getDateFromString(CommonUtil.getStringFromDate(new Date(), "yyyy-MM-dd"), "-");
        let newRepresent = {...represent};
        let representPassportNum = document.getElementById("passportNumber").value;
        if (CommonValidation.Require(representPassportNum)) {
            errorFlg = true;
            repFlgInfo.errPassportNum = true;
        }
        let representIssueYear = document.getElementById("issueYear").value;
        let representIssueMonth = document.getElementById("issueMonth").value;
        let representIssueDay = document.getElementById("issueDay").value;
        let representIssueDate = representIssueDay + " " + representIssueMonth + " " + representIssueYear;
        if (CommonValidation.Require(representIssueDate) || CommonUtil.convPassportDate(representIssueDate, true) == false) {
            errorFlg = true;
            repFlgInfo.errIssueDate = true;
        } else if (today < CommonUtil.getDateFromString(CommonUtil.convPassportDate(representIssueDate, true), "-")) {
            // 当日日付チェック
            errorFlg = true;
            repFlgInfo.errIssueDate = true;
        } else {
            newRepresent.issueDate = representIssueDate;
        }
        let representValidYear = document.getElementById("validYear").value;
        let representValidMonth = document.getElementById("validMonth").value;
        let representValidDay = document.getElementById("validDay").value;
        let representValidDate = representValidDay + " " + representValidMonth + " " + representValidYear;
        if (CommonValidation.Require(representValidDate) || CommonUtil.convPassportDate(representValidDate, true) == false) {
            errorFlg = true;
            repFlgInfo.errValidDate = true;
        } else if (CommonUtil.getDateFromString(CommonUtil.convPassportDate(representValidDate, true), "-") < today) {
            // 当日日付チェック
            errorFlg = true;
            repFlgInfo.errValidDate = true;
        } else {
            newRepresent.validDate = representValidDate;
        }
        passportInfoList.push({
            roomCount: represent.roomCount,
            guestSeq: represent.guestSeq,
            guestNameRoman: represent.guestNameRoman,
            passportNumber: representPassportNum,
            issueDate: representIssueDate,
            validDate: representValidDate,
            representFlg: true
        });
        let newAccompanyList = [...accompanyList];
        newAccompanyList.forEach((accompany, index) => {
            let accFlgInfo = {
                errPassportNum: false,
                errIssueDate: false,
                errValidDate: false
            };
            let accompanyPassportNum = document.getElementById("passportNumber" + index).value;
            if (CommonValidation.Require(accompanyPassportNum)) {
                errorFlg = true;
                accFlgInfo.errPassportNum = true;
            }
            let accompanyIssueYear = document.getElementById("issueYear" + index).value;
            let accompanyIssueMonth = document.getElementById("issueMonth" + index).value;
            let accompanyIssueDay = document.getElementById("issueDay" + index).value;
            let accompanyIssueDate = accompanyIssueDay + " " + accompanyIssueMonth + " " + accompanyIssueYear;
            if (!accompanyIssueDate || CommonUtil.convPassportDate(accompanyIssueDate, true) == false) {
                errorFlg = true;
                accFlgInfo.errIssueDate = true;
            } else if (today < CommonUtil.getDateFromString(CommonUtil.convPassportDate(accompanyIssueDate, true), "-")) {
                // 当日日付チェック
                errorFlg = true;
                accFlgInfo.errIssueDate = true;
            } else {
                accompany.issueDate = accompanyIssueDate;
            }
            let accompanyValidYear = document.getElementById("validYear" + index).value;
            let accompanyValidMonth = document.getElementById("validMonth" + index).value;
            let accompanyValidDay = document.getElementById("validDay" + index).value;
            let accompanyValidDate = accompanyValidDay + " " + accompanyValidMonth + " " + accompanyValidYear;
            if (!accompanyValidDate || CommonUtil.convPassportDate(accompanyValidDate, true) == false) {
                errorFlg = true;
                accFlgInfo.errValidDate = true;
            } else if (CommonUtil.getDateFromString(CommonUtil.convPassportDate(accompanyValidDate, true), "-") < today) {
                // 当日日付チェック
                errorFlg = true;
                accFlgInfo.errValidDate = true;
            } else {
                accompany.validDate = accompanyValidDate;
            }
            passportInfoList.push({
                roomCount: accompany.roomCount,
                guestSeq: accompany.guestSeq,
                guestNameRoman: accompany.guestNameRoman,
                passportNumber: accompanyPassportNum,
                issueDate: accompanyIssueDate,
                validDate: accompanyValidDate,
                ageGroup: accompany.ageGroup
            });
            accFlgList.push(accFlgInfo);
        });
        setRepresentFlgInfo(repFlgInfo);
        setAccompanyFlgList(accFlgList);
        setErrorInfo({
            errorMessage: errorMessageBox,
            errorFlg: errorFlg
        });
        if (errorFlg) {
            errorMessageBox.push(MessageConst.INPUT_ERROR);
            window.scroll({ top: 0, behavior: 'smooth' })
        } else {
            setPassportInfo({
                passportInfoList: passportInfoList,
                represent: newRepresent,
                accompanyList: newAccompanyList,
            });
            history.push("/reserve/rtcc/inputPassportConfirm");
        }

    }

    // 代表者パスポート情報入力
    const handleChangeRepresent = (form) => {
        let input = document.getElementById(form).value;
        let newRepresent = {...represent};
        newRepresent[form] = input;
        setRepresent(newRepresent);
    }
    // 同行者パスポート情報入力
    const handleChangeAccompany = (form, index) => {
        let input = document.getElementById(form + index).value;
        let newList = [];
        accompanyList[index][form] = input;
        accompanyList.map((value) => {
            newList.push(value)
        })
        setAccompanyList(newList);
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="パスポート情報入力"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
            </div>
            <div className="reserveConirmWrapper">
                <div className="reserveContentWrapper">
                    <Label label="ご予約内容" className="reserveConirmTitle2" />
                    <div className="reservationContentsWrap">
                        <div className="reservationContents">
                            <Label
                                label="ご利用日程"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="施設名"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="お部屋タイプ"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.roomType}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="予約番号"
                                className="inputTitleLabel"
                            />
                            <Label
                                label={toUserInputInfo.reserveId}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* パスポート情報入力フォーム */}
            <InputPassportList
                inputFlg={true}
                representData={represent}
                accompanyList={accompanyList}
                representFlgInfo={representFlgInfo}
                accompanyFlgList={accompanyFlgList}
                yearListIssued={yearListIssued}
                yearListValid={yearListValid}
                monthList={monthList}
                dayList={dayList}
                errorInfo={errorInfo}
                titleClassName="titleLabel"
                handleChangeRepresent={handleChangeRepresent}
                handleChangeAccompany={handleChangeAccompany}
            />
            <div className="btnToConfirmWrapper">
                <div className="confirmboxWrap">
                    <Button buttonText="戻る" className="btnBack" onClick={onClickBack} buttonClassName="serachBtnText" />
                    <Button buttonText="確認画面へ" className="btnToConfirm" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                </div>
                <div style={styles.bottomLinkArea}>
                    <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        checkIn: state.checkIn,
        passportInfo: state.passportInfo,
        toUserInputInfo: state.toUserInputInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setPassportInfo: (item) => {
            dispatch({ type: "PASSPORT_INFO", payload: { passportInfo: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccInputPassportContainer);

const styles = {
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        padding: "15px 0px 15px 0px",
        textAlign: "center",
    },
    bottomLink: {
        padding: "3px",
        color: "rgb(105, 105, 105)",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    confirmbox: {
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexWrap: "wrap",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "50px 0px 0px 0px",
    },
    reservationInfoWrapper: {
        width: "90%",
        textAlign: "center",
        margin: "auto",
    },
    reservationInfo: {
        display: "flex",
        flexWrap: "wrap",
        textAlign: "left",
        margin: "auto",
        justifyContent: "center"
    },
    waveDash: {
        display: "flex",
        margin: "5px 0 5px 0px",
        alignItems: "center"
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0.94)",
        border: 0,
        fontWeight: "bold"
    }
}